// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

export const InterimSoldOut = styled.div`
  background-color: ${(props) =>
    props.theme.brandSpecificStyles.EMPTY_CATEGORY_BANNER.INTERIM_SOLD_OUT_BACKGROUND_COLOR};
  height: auto;
  text-transform: unset !important;
`;

export const CategoryNameDiv = styled.div`
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy13}px;
  text-align: center;
  font-family: Nunito;
  color: ${(props) => props.theme.colors.WHITE};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  letter-spacing: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
`;

export const AnchorStyle = styled(Anchor)`
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy9}px;
  text-align: center;
  text-decoration: underline;
  font-family: Nunito;
  color: ${(props) => props.theme.colors.WHITE};
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  line-height: 1.23;
  letter-spacing: ${(props) => props.theme.fonts.letterSpacing.normal};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
`;

export const DepartmentMsgDiv = styled.div`
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy9}px;
  text-align: center;
  font-family: Nunito;
  text-transform: unset !important;
  color: ${(props) => props.theme.colors.WHITE};
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  line-height: 1.23;
  letter-spacing: ${(props) => props.theme.fonts.letterSpacing.normal};
  padding-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXL};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
`;

export const ContainerDiv = styled.div`
  @media ${(props) => props.theme.mediaQuery.large} {
    margin-right: ${(props) => (props.isHPLP ? 'auto' : 'calc(2% + 3px)')};
  }
`;

export const SectionGap = styled.div`
  height: ${(props) => props.height || 30}px;
`;
